export default __webpack_public_path__ + "static/media/my-desk-glyph-16px.62cefd7b.svg";